const zhArticle = {
  'badge.exclusive': '独家黑料',
  'btn.watchVideo': '查看完整视频 / 线路一',
  'highlight.title': '核心原话摘录',
  'related.title': '看完这篇还不过瘾',
  'related.subtitle': '更多猛料等你来挖',
  'subscribe.title': '追踪<span class="italic font-light text-foreground-400">后续反转</span>',
  'subscribe.btn': '加入讨论',
};

export default zhArticle;